import { useEffect, useRef } from 'react';

export const useLatestRef = (value) => {
	const ref = useRef(value);

	// Keep the latest value available to stable callbacks without forcing them to re-register.
	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref;
};
